import { render, staticRenderFns } from "./MailingsTablePartner.vue?vue&type=template&id=527d43e7&"
import script from "./MailingsTablePartner.vue?vue&type=script&lang=js&"
export * from "./MailingsTablePartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports